import { Box, Typography, TextField, Button } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const NotFound = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: 2,
      }}
    >
      <Typography variant="h2" sx={{ fontWeight: "bold", marginBottom: 2 }}>
        Erro 404
      </Typography>
      <Typography variant="body1" sx={{ marginBottom: 4 }}>
        Ops, não conseguimos encontrar a página que você procura.
        <br />
        Que tal fazer uma busca na nossa pesquisa avançada no campo abaixo? :)
      </Typography>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          maxWidth: 600,
          width: "100%",
        }}
      >
        <TextField
          variant="outlined"
          placeholder="Digite sua busca"
          fullWidth
          sx={{
            borderRadius: "4px",
            backgroundColor: "#f5f5f5",
          }}
        />
        <Button variant="contained" color="primary" sx={{ padding: "10px 20px" }}>
          <SearchIcon />
        </Button>
      </Box>
      <Box
        sx={{
          marginTop: 4,
          display: "flex",
          flexDirection: "row",
          gap: 2,
        }}
      >
        <Button
          variant="outlined"
          color="primary"
          onClick={() => window.location.href = "/"} // Redireciona para a página inicial
        >
          Quero voltar para a página inicial
        </Button>
        <Button variant="outlined" color="secondary">
          Quero reportar que essa página não está funcionando
        </Button>
      </Box>
    </Box>
  );
};

export default NotFound;
